import { Button, ConfigProvider, ImagePreview, Overlay, Uploader } from "react-vant";
import "./index.less";
import { Plus } from "@react-vant/icons";
import { useSearchParams } from "react-router-dom";
import Upload from "@/components/Upload";
import tipImg from "@/assets/images/tip.png";
import uploadStore from "@/store/upload";
import { observer } from "mobx-react";
import { useEffect, useMemo, useState } from "react";
import { getScriptDetail, updateScript } from "@/server";
import { Helmet } from "react-helmet";

declare global {
  interface Window {
    wx: any;
  }
}

const Webview = () => {
  const [searchParams] = useSearchParams();
  const method = searchParams.get("method") ?? "media";
  const token = searchParams.get("token");
  const scriptId = searchParams.get("script_id");
  const sceneIndex = searchParams.get("scene_index");
  const sceneTitle = searchParams.get("scene_title");
  localStorage.setItem("token", token ?? "");
  const [videoItem, setVideoItem] = useState<any>();
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    console.log(111, scriptId, sceneIndex);
    if (uploadStore.isFinish && uploadStore.uploadList.length) {
      if (!scriptId || !sceneIndex) return;
      getScriptDetail(scriptId).then((res) => {
        console.log("script detail", JSON.parse(res.item.content), uploadStore.uploadList);
        let scenes = JSON.parse(res.item.content);
        const materials = scenes[sceneIndex].materials || [];
        const materialIds = materials.map((p) => p.id);
        uploadStore.uploadList.forEach((item) => {
          if (!materialIds.includes(item.result.id)) materials.push(item.result);
        });
        scenes = scenes.map((scene, index) => {
          return index === +sceneIndex
            ? {
                ...scene,
                materials: materials,
              }
            : scene;
        });
        console.log("scenes", scenes);
        updateScript(scriptId, {
          ...res.item,
          content: JSON.stringify(scenes),
          title: "",
        });
      });
    }
  }, [uploadStore.isFinish]);

  const accept = useMemo(() => {
    console.log("scriptId", scriptId, "method", method, method === "composition", !!scriptId);

    if (method === "composition" || !!scriptId) {
      return "video/*";
    } else {
      return "image/*,video/*";
    }
  }, [method, scriptId]);

  // useEffect(() => {
  //   // // 修改标题
  //   // document.title = sceneTitle;
  //   // // 模拟每5秒更新一次共享数据
  //   // const timer = setInterval(() => {
  //   //   window.wx.miniProgram.getEnv(function (res) {
  //   //     console.log(res); // true
  //   //   });
  //   // }, 500);
  //   // return () => clearInterval(timer);
  // }, []);

  const handleClick = (item) => {
    console.log(111, item);
    if (item.fileType === "image") {
      ImagePreview.open({
        images: [item.cover],
      });
    } else {
      setVideoItem(item);
      setShowOverlay(true);
    }
  };

  return (
    <div className="home">
      <Helmet>
        <title>{sceneTitle || "摘星方舟"}</title>
      </Helmet>
      <div className="tip">
        <div className="title">
          <img src={tipImg} alt="" />
          <div>友情提示</div>
        </div>

        <ul>
          <li>1.为了减少等待时间，每次最多上传 5 个文件 </li>
          <li>2.若上传过程中离开当前页，上传过程中的文件会丢失哦</li>
          <li>3.此次上传大概需要1分钟左右的时间，请您耐心等待</li>
        </ul>
      </div>
      <Upload
        imgSize="16vw"
        accept={accept}
        triggerElement={
          <div className="upload-btn">
            <Button
              block
              round
              icon={<Plus />}
              style={{
                background: "linear-gradient( 131deg, #575CFF 0%, #A866FF 100%)",
                color: "#fff",
              }}
            >
              上传素材
            </Button>
            <div className="tips">最多批量上传 5 个文件，单个文件大小不超过1 GB</div>
          </div>
        }
        onItemClick={handleClick}
        onItemUploadSuccess={(v) => {
          console.log("item success", v);
        }}
      />

      <Overlay visible={showOverlay}>
        <div className="close" onClick={() => setShowOverlay(false)}>
          <i className="iconfont icon-closel"></i>
        </div>
        {!!videoItem && (
          <video controls style={{ width: "100%", height: "100%" }} poster={videoItem.cover}>
            <source src={videoItem.url} type="video/mp4" />
          </video>
        )}
      </Overlay>
    </div>
  );
};

export default observer(Webview);
